import React from 'react'
import cx from 'classnames'

import { Text, type TextColor, type TextStyle } from 'components/dataDisplay'


export type OrderBillItemProps = {
  className?: string
  disabled?: boolean
  label: string | Intl.Message
  note?: string | Intl.Message
  noteColor?: TextColor
  noteStyle?: TextStyle
  size?: 'medium' | 'big' | 'large'
  'data-testid': string
} & AtLeastOne<{
  value: string | Intl.Message
  valueNode: React.ReactNode
}>

const OrderBillItem: React.FunctionComponent<OrderBillItemProps> = (props) => {
  const { className, disabled, label, note, noteColor, noteStyle, value, valueNode, size = 'medium', 'data-testid': dataTestId } = props

  const priceColor = (size === 'big' || size === 'large') ? 'gold-50' : 'black'

  let labelStyle: TextStyle = 'p2'
  if (size === 'big') {
    labelStyle = 'p1'
  }
  else if (size === 'large') {
    labelStyle = 'h7'
  }

  let priceStyle: TextStyle = 't2'
  if (size === 'big') {
    priceStyle = 't1'
  }
  else if (size === 'large') {
    priceStyle = 'h7'
  }

  return (
    <div className={cx(className, 'flex justify-between')} data-testid={dataTestId}>
      <div>
        <Text
          message={label}
          style={labelStyle}
          color="black"
          data-testid={`${dataTestId}Label`}
        />
        {
          Boolean(note) && (
            <Text
              className="mt-4"
              message={note}
              style={noteStyle || 'p4'}
              color={noteColor || 'gray-80'}
              html
              data-testid={`${dataTestId}Note`}
            />
          )
        }
      </div>
      {
        valueNode ? (
          valueNode
        ) : (
          <Text
            className="ml-16 whitespace-nowrap"
            message={value}
            style={priceStyle}
            color={disabled ? 'gray-50' : priceColor}
            data-testid={`${dataTestId}Value`}
          />
        )
      }
    </div>
  )
}


export default OrderBillItem
